<!-- 页面内容 -->

<template>
    <!-- container -->
    <div class='content'>
        <div class="container cont">
            <div class="contV">
                <div class="tabA">
                    <div class="tabAV">
                        <div class="name">Order Status</div>
                        <!-- 待确认  1 -->
                        <div class="tabL" :class="numI == 0 ? 'tabL1' : ''" @click="goTab(0)">
                            <div v-if="numI == 0" class="blockB"></div>
                            Order Confirm
                        </div>
                        <!-- 待发货  2 -->
                        <div class="tabL" :class="numI == 1 ? 'tabL1' : ''" @click="goTab(1)">
                            <div v-if="numI == 1" class="blockB"></div>
                            Prepare for Shipping
                        </div>
                        <!-- 待收货  3 -->
                        <div class="tabL" :class="numI == 2 ? 'tabL1' : ''" @click="goTab(2)">
                            <div v-if="numI == 2" class="blockB"></div>
                            Delivery
                        </div>
                        <!-- 已完成  4 -->
                        <div class="tabL" :class="numI == 3 ? 'tabL1' : ''" @click="goTab(3)">
                            <div v-if="numI == 3" class="blockB"></div>
                            Finished
                        </div>
                    </div>
                </div>

                <div class="tabB" v-loading="loading">
                    <div class="tabBV">
                        <div class="name">Orders details</div>
                        <div class="List" v-for="(item, index) in FlashList" :key="index">
                            <div class="List1">
                                <div class="xq">
                                    <span class="xq1">Order ID：</span>
                                    <span class="xq2">{{ item.sn }}</span>
                                    <span class="xq3" style="margin-left: 12px;">time：</span>
                                    <span class="xq4">{{ item.createTime }}</span>
                                </div>
                                <div class="title" v-if="item.status == '1'">Awaiting Confirmation</div>
                                <div class="title" v-if="item.status == '4'">Completed</div>
                            </div>
                            <div class="List2" v-for="(items, index) in item.goods" :key="index">
                                <img class="photoV" :src="items.thumbnail" alt="" />
                                <div class="numV">
                                    <div class="numV1">{{ items.goodsName }}</div>
                                    <div class="numV2" style="margin-top: 8px;">nicotine content:{{ items.content }}</div>
                                    <div class="numV3" style="margin-top: 4px;">flavor:{{ items.falvorName }}</div>
                                    <div class="numV4" style="margin-top: 8px;">
                                        <div class="numV41">X{{ items.number }}</div>
                                        <div class="numV42">
                                            <span>unit price</span>
                                            <span style="margin-left: 10px;">${{ items.goodsPrice }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="titleVvv">
                                <div></div>
                                <div class="numV42">
                                    <span>Discount</span>
                                    <span>${{ item.discountsPrice }}</span>
                                    <span style="margin-left: 10px;">Total</span>
                                    <span>${{ item.ordersPrice }}</span>
                                </div>
                            </div>
                            <p style="font-size: 14px;color: #999;margin: 0 0 20px;">Consignee Information</p>
                            <div class="addressX">{{ item.name }}</div>
                            <div class="addressX">{{ item.address }}</div>
                            <!-- //状态（1-待确认、2-待发货、3-待收货、4-已完成） -->
                            <!-- <div class="btnVV" v-if="item.status == '1'">
                                <div></div>
                                <div class="btnV" @click="getPay(item)">Pay Now</div>
                            </div> -->
                            <div class="btnVVV" v-if="item.status == '3'">
                                <div></div>
                                <div class="btnVV" @click="getfulfil(item.ordersId)">Confirm Receipt</div>
                            </div>
                            <div class="lines"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {
    MessageBox
} from 'element-ui'
export default {
    data() {
        return {
            loading: false,
            numI: 0,
            FlashList: []
        }
    },
    mounted() {
        this.listFlashApi(this.numI);
    },
    methods: {
        getPay(info) {
            MessageBox.confirm(
                'Is payment confirmed?',
                'hint', {
                confirmButtonText: 'confirm',
                cancelButtonText: 'cancel',
                type: 'warning',
            }
            ).then(async () => {
                try {
                    const res = await this.$post('system/orders/quickOrders', {

                    });
                    this.$message({
                        message: res.msg,
                        type: 'success'
                    });
                    this.listFlashApi(this.numI);
                } catch (error) {
                }
            })
            console.warn(info, "info")
        },
        // system/orders/fulfil?ordersId=1
        getfulfil(id) {
            MessageBox.confirm(
                'Confirm receipt of goods',
                'hint', {
                confirmButtonText: 'confirm',
                cancelButtonText: 'cancel',
                type: 'warning',
            }
            ).then(async () => {
                try {
                    const res = await this.$PUT('system/orders/fulfil?ordersId=' + id);
                    this.$message({
                        message: res.msg,
                        type: 'success'
                    });
                    this.listFlashApi(this.numI);
                } catch (error) {
                }
            })
        },
        // -订单列表   system/orders/listOrders?status=&type=&pageNum=&pageSize=4
        // 状态（0-待付款、1-待确认、2-待发货、3-已发货、4-已完成）
        async listFlashApi(idx) {
            this.loading = true;
            try {
                const res = await this.$get('system/orders/listOrders', {
                    status: idx + 1,
                    type: '',   //类型（0-普通、1-秒杀）
                    pageNum: 1,
                    pageSize: 999
                });
                console.warn(res, "订单列表");
                this.loading = false;
                this.FlashList = res.rows || [];
                // console.warn(this.FlashList)
            } catch (error) {
            }
        },
        goTab(e) {
            this.numI = e;
            this.listFlashApi(e);
        }
    },
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>